<ion-header class="main-header ion-no-border" >
  <div class="left-section">
    <app-new-likes-icon 
      [refreshMyData] = "refreshMyData ? refreshMyData.bind(this) : undefined"
      [vegBoostEnable] = "this.vegBoostEnable"
      [unregisterFunction] = "unregisterFunction">
    </app-new-likes-icon> 
  </div>

  <div class="right-section">
    <ion-icon
      alt="Open teleportation" 
      [src]="teleportationEnable
      ? 'assets/imgs/custom-svg/teleportation.svg'
      : 'assets/imgs/custom-svg/teleportation_outline.svg'"
      [class.teleportation-icon-enabled]="teleportationEnable"
      [class.teleportation-icon-disabled]="!teleportationEnable"
      class="teleportation-icon"
      (click)="teleportationClicked.emit()">
    </ion-icon>

    <ion-icon
      alt="Open filters" 
      [src]="filtersEnable
      ? 'assets/imgs/custom-svg/filter.svg'
      : 'assets/imgs/custom-svg/filter_outline.svg'"
      [class.filter-icon-enabled]="filtersEnable"
      [class.filter-icon-disabled]="!filtersEnable"
      class="filter-icon"
      (click)="preferencesClicked.emit()">
    </ion-icon>
  </div>

</ion-header>